import Box from "@mui/material/Box";
import Stack from "@mui/system/Stack";
import React from 'react';
import { blockStyle, headerStyle, contentStyle, titleStyle } from './BlockTypeB.style';
export const BlockTypeB = ({ dataQa = 'block-type-b', title, titleSx, headerContent, content }) => {
    return (React.createElement(Box, { sx: blockStyle, "data-qa": dataQa },
        React.createElement(Box, { sx: headerStyle, "data-qa": `${dataQa}-header` },
            React.createElement(Stack, { direction: "row", spacing: 2, justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" },
                React.createElement(Box, { sx: titleSx ? titleSx : titleStyle, "data-qa": `${dataQa}-header-title` }, title),
                headerContent && (React.createElement(Box, { "data-qa": `${dataQa}-header-content` }, headerContent)))),
        React.createElement(Box, { sx: contentStyle, "data-qa": `${dataQa}-content` }, content)));
};
